import { createContext } from "react";
import { State } from "../types";

type TilesStateType = State<string[]>;

export const TileContext = createContext<TilesStateType>([
  [],
  () => {}
]);